export const DARK_THEME_PRESET = {
  primary_color: '#E7C65C',
  secondary_color: '#57D6A5',
  accent_highlight: '#73DDF2',
  glow_1: '#FFE86B',
  glow_2: '#7EF3BE',
  glow_3: '#7BC5FF',
  glow_4: '#FF9D57',
  glow_5: '#D39DFF',
  glow_6: '#FF7AA2',
  bg_base: '#0B1020',
  bg_surface: '#121826',
  bg_elevated: '#1A2333',
  dropdown_bg: '#1A2333',
  dropdown_text: '#F8FAFC',
  dropdown_hover_bg: '#243047',
  text_primary: '#F8FAFC',
  text_secondary: '#AEB8C7',
  text_muted: '#6B7280',
  border_subtle: 'rgba(148,163,184,0.18)',
  border_strong: 'rgba(148,163,184,0.30)',
  button_radius: '12px',
};

export const LIGHT_THEME_PRESET = {
  primary_color: '#7A4D00',
  secondary_color: '#0F5F3A',
  accent_highlight: '#0D4D73',
  glow_1: '#B67A00',
  glow_2: '#0F766E',
  glow_3: '#0F7C95',
  glow_4: '#C05621',
  glow_5: '#7C3AED',
  glow_6: '#BE185D',
  bg_base: '#F6F8FB',
  bg_surface: '#FFFFFF',
  bg_elevated: '#EDF2F7',
  dropdown_bg: '#FFFFFF',
  dropdown_text: '#0F172A',
  dropdown_hover_bg: '#EDF2F7',
  text_primary: '#0F172A',
  text_secondary: '#334155',
  text_muted: '#64748B',
  border_subtle: 'rgba(15,23,42,0.10)',
  border_strong: 'rgba(15,23,42,0.18)',
  button_radius: '12px',
};

export const DEFAULT_THEME_SETTINGS = {
  ...DARK_THEME_PRESET,
  dark_theme: DARK_THEME_PRESET,
  light_theme: LIGHT_THEME_PRESET,
};

export function mergeThemeSettings(settings = {}) {
  return {
    ...DEFAULT_THEME_SETTINGS,
    ...settings,
    dark_theme: { ...DARK_THEME_PRESET, ...(settings.dark_theme || {}) },
    light_theme: { ...LIGHT_THEME_PRESET, ...(settings.light_theme || {}) },
  };
}
